import React from 'react';

interface PrimaryButtonProps {
  text: string;
  onClick: () => void;
  disable?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ text, onClick, disable }) => {
  return (
    <button onClick={() => !disable && onClick()} className={`w-full rounded-lg border-0 bg-btPrimary py-4`}>
      <div className={`text-base font-semibold leading-5 text-btText ${disable ? 'opacity-30' : ''}`}>{text}</div>
    </button>
  );
};

export default PrimaryButton;
